import { session } from 'wix-storage';
import wixLocation from 'wix-location';
import { biLoggerFactory } from 'wix-private';
import { sidebar } from 'public/sidebar.js'

const biLogger = biLoggerFactory('xdc', 110, { msid: 'aec9caf7-41a4-4d4f-9c35-6b558a2f9427' });

let Buttons = {
    startCreating: "Start Creating",
    openEditorX: "Open Editor X",
    startDesign: "Start Design",
    getSkilledUp: "Get skilled up",
    joinTheDiscussion: "Join the discussion",
    readArticles: "Read articles",
    daniel: "Daniel Aristizábal",
    amber: "Amber Vittoria",
    zipeng: "Zipeng Zhu",
    david: "David Milan",
}

$w.onReady(function () {
    sidebar();
    const sidebarHomeBtn = $w('#sidebarHomeBtn');
    sidebarHomeBtn.style.color = 'white';
    sidebarHomeBtn.style.backgroundColor = '#212121';
    activeSecondFoldCardsClick();

    addBiEvents();
});

function activeSecondFoldCardsClick() {
    const cards = ['#card01', '#card02', '#card03', '#card04', '#card05', '#card06', '#card07', '#card08'];

    cards.forEach(card => {
        $w(card).onClick(() => {
            let url = $w(card).children[3].children[1].link;
            session.setItem('page', 'Home Page');
            wixLocation.to(url);
        });
    });
}

function addBiEvents() {
    $w('#fromXteamCTA').onClick(() => {
        CTAClickEvent(Buttons.readArticles, 1)
        wixLocation.to($w('#fromXteamCTA').link);
    })

    //*** Missing image click bi event ***/

    // $w('#heroTopRightImage').onClick(() => {
    //     CTAClickEvent(Buttons.VeloWebinar, 1)
    //     wixLocation.to('/from-x-team/sticky-gallery')
    // });

    // $w('#heroTopRightImageMobile').onClick(() => {
    //     CTAClickEvent(Buttons.VeloWebinar, 1)
    //     wixLocation.to('/from-x-team/sticky-gallery')
    // })

    //** Missing mobile image click bi event **/

    // $w('#heroMainImage').onClick(() => {
    //     thumbnailClickEvent()
    //     wixLocation.to('/video-tutorials/concurrent-editing')
    // })
}

//---------------------CTA EVENTS-------------------------
export async function CTAClickEvent(buttonName, location) {
    try {
        const biEventObject = {
            evid: 2001,
            cta_location: location,
            cta_name: buttonName,
            topic: "Design Classes",
            brand_name: 'editor x'
        };
        await biLogger.log(biEventObject);
    } catch (err) {
        console.log(err, "sth went wrong")
    }
}

export function box50_click(event) {
    CTAClickEvent('Class with Zipeng Zhu', 'Fold 1')
}

export function box53_click(event) {
    CTAClickEvent('Live site building demo', 'Fold 1')
}

export function heroMainCTAbiBox_click(event) {
    CTAClickEvent('Watch now', 'Fold 1')
}

export function cardCTAbiBox01_click(event) {
    CTAClickEvent('Watch now', 'New in Academy X - Sections')
}

export function cardCTAbiBox02_click(event) {
    CTAClickEvent('Start lesson', 'New in Academy X - Layouter')
}

export function cardCTAbiBox03_click(event) {
    CTAClickEvent('Watch now', 'New in Academy X - Inspector panel')
}

export function cardCTAbiBox04_click(event) {
    CTAClickEvent('Start lesson', 'New in Academy X - Grid')
}

export function cardCTAbiBox05_click(event) {
    CTAClickEvent('Watch now', 'Popular in Academy X - Grid')
}

export function cardCTAbiBox06_click(event) {
    CTAClickEvent('Start lesson', 'Popular in Academy X - Overflow')
}

export function cardCTAbiBox07_click(event) {
    CTAClickEvent('Watch now', 'Popular in Academy X - Site Structure')
}

export function cardCTAbiBox08_click(event) {
    CTAClickEvent('Start lesson', 'Popular in Academy X - Stack')
}

export function fromXCTAbiBox_click(event) {
    CTAClickEvent('Read article', 'Fold 3')
}

//--------------------THUMBNAIL EVENTS------------------------------------
export async function thumbnailClickEvent(artistName, className, videoFullLengthSeconds, videoLocation, videoType) {
    //Add your code for this event here: 
    const biEventObject = {
        evid: 2002,
        artistName,
        className,
        videoFullLengthSeconds,
        videoLocation,
        videoType,
        topic: 'Design Classes',
        brand_name: 'editor x'
    };
    await biLogger.log(biEventObject);
}
export function heroMainStack_click(event) {
    thumbnailClickEvent('', 'Introduction to EditorX', '2:51', 'Fold 1', 'intro')
}

export function upNext01imageBox_click(event) {
    thumbnailClickEvent('', 'Sections', '4:22', 'New in Academy X', 'class')
}

export function upNext03imageBox_click(event) {
    thumbnailClickEvent('', 'Inspector panel', '3:46', 'New in Academy X', 'class')
}

export function box637_click(event) {
    thumbnailClickEvent('', 'Grid', '2:20', 'Popular in Academy X', 'class')
}

export function box623_click(event) {
    thumbnailClickEvent('', 'Stack', '2:20', 'Popular in Academy X', 'class')
}

//---------------------------LESSONS EVENTS----------------------------
export async function lessonClickEvent(artistName, lessonName) {
    try {
        const biEventObject = {
            evid: 2004,
            artistName,
            lessonName,
            topic: "Design Classes",
            brand_name: 'editor x'
        };
        await biLogger.log(biEventObject);
    } catch (err) {
        console.log(err, "sth went wrong")
    }
}

// -------------------------------------------------------------------------



export function heroMainImage_click(event) {
    session.setItem('page', 'Home page')
    wixLocation.to('/video-tutorials/concurrent-editing');
}

export function heroTopRightBox_click(event) {
    wixLocation.to('/from-x-team/sticky-gallery');
}

export function heroTopRightCTABox_click(event) {
    wixLocation.to('/from-x-team/sticky-gallery');
}

export function heroBottomRightBox_click(event) {
    wixLocation.to('https://www.editorx.com/academy/webinars#comp-kfcn1kv3')
}

export function heroBottomRightCTABox_click(event) {
    wixLocation.to('https://www.editorx.com/academy/webinars#comp-kfcn1kv3')
}